import { render, staticRenderFns } from "./TicketCompanyViewer.vue?vue&type=template&id=e220d1f0&scoped=true"
import script from "./TicketCompanyViewer.vue?vue&type=script&lang=js"
export * from "./TicketCompanyViewer.vue?vue&type=script&lang=js"
import style0 from "./TicketCompanyViewer.vue?vue&type=style&index=0&id=e220d1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e220d1f0",
  null
  
)

export default component.exports